<template>
    <v-card class="rounded-lg">
        <slot />
        <v-card-text class="pb-0 pt-5">
            <slot name="content"></slot>
        </v-card-text>
        <v-card-actions class="px-6 pb-5 pt-0">
            <!-- <v-spacer></v-spacer> -->
            <slot name="actions"></slot>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {}
</script>

<style></style>
